module.exports = __webpack_public_path__ + "static/media/skip-2.082d5f93.jpeg";